"use client";

import { useContext, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { useTranslations } from "next-intl";
import Button from "./Button";
import Image from "next/image";
import { SignatureDataContext } from "../digital-signature/SignatureDataContext";

const SignaturePad = () => {
  const sigCanvas = useRef<SignatureCanvas>(null);

  const constext = useContext(SignatureDataContext);
  if (!constext) {
    throw new Error("SignatureDataContext is not available");
  }
  const { signatureData, setSignatureData } = constext;

  const t = useTranslations("ProposalStepper.steps.sign.signature_pad");

  const [error, setError] = useState<string | null>(null);

  // Clear the canvas
  const clear = () => {
    sigCanvas.current?.clear();
    setSignatureData(null);
  };

  // Save as Base64
  const save = () => {
    if (sigCanvas.current) {
      if (sigCanvas.current.isEmpty()) {
        setError(t("no_sign"));
        return;
      }

      if (error) setError(null);

      const base64String = sigCanvas.current
        .getTrimmedCanvas()
        .toDataURL("image/png");

      setSignatureData(base64String);
      console.log("Base64 Signature:", base64String);
    }
  };

  return (
    <div
      className={`flex flex-col items-center gap-4 p-4 bg-surface rounded-xl border max-w-full ${error ? "border-accent" : "border-border"}`}
    >
      <h3 className="font-bold m-0!">{t("sign_here")}</h3>

      {signatureData ? (
        <div className="relative max-w-full w-75 aspect-300/150 flex items-center justify-center">
          <Image
            src={signatureData as string}
            alt="User digital signature visual representation"
            fill
            className="border border-border p-2"
          />
        </div>
      ) : (
        <div className="border-2 border-dashed border-gray-300 rounded-lg bg-white">
          <SignatureCanvas
            ref={sigCanvas}
            penColor="black"
            canvasProps={{
              width: 300,
              height: 150,
              className: "signature-canvas max-w-full!",
            }}
          />
        </div>
      )}

      <div className="flex w-full justify-between gap-2">
        <Button
          fill="transparent"
          onClick={clear}
          className="px-4 py-2 bg-gray-200 rounded-md"
        >
          {t("clear_sign")}
        </Button>

        <Button
          onClick={save}
          className="px-4 py-2 bg-primary text-white rounded-md"
        >
          {t("save_sign")}
        </Button>
      </div>

      {error && <p className="text-sm text-accent m-0!">{error}</p>}
    </div>
  );
};

export default SignaturePad;
